
module.exports = {"attributes":{"width":"18","height":"13","viewBox":"0 0 18 13"},"content":"<path d=\"M18 3.5v8l-1.5 1.5h-15l-1.5-1.5v-8l1.5-1.5h3.5l2-2h4l2 2h3.5l1.5 1.5zm-9 7.5c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
